import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  sortNumeric,
  selectFormat,
  Error,
  getMetricForColumn,
} from "components/Utils/Utils";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

class SocialPostBenchmark extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  findFirstNumericColumn(cells, data) {
    for (let i = 0; i < cells.length; i++) {
      const key = cells[i];
      const item = data[key];
      // Check if the item exists and its 'value' is a number
      if (item && typeof item.value === "number") {
        return key;
      }
    }
    return null;
  }

  renderTable(data) {
    const { cells, title } = this.props;

    // add unique ids
    data.forEach((d, i) => {
      d.id = i;
    });

    const columns = [
      {
        dataField: "handle",
        text: "Handle",
        style: { width: "120px", minWidth: "120px", textAlign: "left" },
        headerAlign: "left",
        csvFormatter: (cell, row) => row.handle,
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "dimension",
        text: "Dimension",
        style: { width: "120px", minWidth: "120px", textAlign: "left" },
        headerAlign: "left",
        csvFormatter: (cell, row) => row.handle,
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "line_items",
        text: "Line Items",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "post_type",
        text: "Post Type",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        csvFormatter: (cell, row) => row.post_type,
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "published",
        text: "# Published",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) => selectFormat("csv_number", cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "reach",
        text: "Reach",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "engagements",
        text: "Engagements",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "impressions",
        text: "Impressions",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "total_spend",
        text: "Total Spend",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "engagement_rate",
        text: "Engagement Rate",
        style: { width: "90px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "video_views_25_percent",
        text: "Video Views 25%",
        style: { width: "90px", minWidth: "120px" },
        formatter: getMetricForColumn,
        // formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "video_views_50_percent",
        text: "Video Views 50%",
        style: { width: "90px", minWidth: "120px" },
        formatter: getMetricForColumn,
        // formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "video_views_75_percent",
        text: "Video Views 75%",
        style: { width: "90px", minWidth: "120px" },
        formatter: getMetricForColumn,
        // formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "audible_impressions",
        text: "Audible Impressions",
        style: { width: "140px", minWidth: "140px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "view_rate",
        text: "View Rate",
        style: { width: "90px", minWidth: "90px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "video_completion_rate",
        text: "View Completion Rate",
        style: { width: "120px", minWidth: "130px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "completion_rate",
        text: "Completion Rate",
        style: { width: "120px", minWidth: "130px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "cpcv",
        text: "CPCV",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },

      // {
      //   dataField: "reach_rate",
      //   text: "Reach Rate",
      //   style: { width: "90px", minWidth: "90px" },
      //   formatter: getMetricForColumn,
      //   formatExtraData: { type: "percentage" },
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0.000%"),
      // },
    ];

    const defaultSortName = this.findFirstNumericColumn(
      this.props.cells,
      this.props.data.data[0]
    );

    const defaultSorted = [
      {
        dataField: defaultSortName,
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";

    const pagination = paginationFactory({
      sizePerPage: 10,
      hideSizePerPage: true,
    });

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            pagination={pagination}
            filter={filterFactory()}
            defaultSorted={defaultSorted}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default SocialPostBenchmark;
